
export default class OverSymbolReel extends PIXI.Container  {
  constructor() {
    super()
  }
}
